<template>
  <v-container>
    <front-search v-if="!isAdmin && searchEnabled" v-model="query" @submitautocomplete="submitAutocomplete"></front-search>
    <v-row>
      <v-col cols="4" v-if="searchEnabled">
        <form v-on:submit.prevent="updateResults(1)" v-if="isAdmin">
          <v-row>
            <v-col cols="8">
              <v-text-field v-model="query" :label="Translator('admin.notice_collection.facets.search')"></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-btn type="submit" :loading="isListLoading">
                <v-icon dark>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </form>
        <div v-if="isAdmin">
          <v-radio-group v-model="onlyHasImage" row @change="updateResults(1)">
            <v-radio :label="Translator('admin.notice_collection.facets.image_all')" value="all"></v-radio>
            <v-radio :label="Translator('admin.notice_collection.facets.image_with')" :value="true"></v-radio>
            <v-radio :label="Translator('admin.notice_collection.facets.image_without')" :value="false"></v-radio>
          </v-radio-group>
          <v-radio-group v-model="onlineFilter" row @change="updateResults(1)">
            <v-radio :label="Translator('admin.notice_collection.facets.filter_all')" value="all"></v-radio>
            <v-radio :label="Translator('admin.notice_collection.facets.filter_online')" value="online"></v-radio>
            <v-radio :label="Translator('admin.notice_collection.facets.filter_offline')" value="offline"></v-radio>
          </v-radio-group>
          <v-select
              v-model="noticeCollectionsFilter"
              :items="noticeCollections"
              label="Collections"
              multiple
              chips
              item-text="name"
              item-value="code"
              return-object
              @change="updateResults(1)"
              deletable-chip="true"
              persistent-hint
          ></v-select>
          <v-chip
              v-for="selectedFacet in selectedFacets" :key="selectedFacet.id"
              class="ma-2"
              close
              @click:close="removeFacet(selectedFacet)"
          >
            {{ selectedFacet.name }}
          </v-chip>
        </div>
        <v-treeview
            item-key="id"
            item-children="children"
            item-text="content"
            selectable
            :items="facets"
            :load-children="fetchFacets"
            :open.sync="openedFacets"
            @input="updateResults(1)"
            v-model="selectedFacets"
            transition
            return-object
            selection-type="independent"
            open-on-click
            ref="tree"
        ></v-treeview> <!--- weard bug https://stackoverflow.com/a/66187402/5873234 --->
        <v-btn v-if="!isAdmin" @click="addResultToCart">{{ Translator('admin.notice_collection.facets.add_select_to_card') }}</v-btn>
        <notice-most-views v-if="showMostViewsNotices"></notice-most-views>
      </v-col>
      <v-col class="8">
        <h3 v-if="totalNotices !== null">{{ Translator('admin.notice_collection.facets.notice_total', {'length': totalNotices}) }}</h3>
        <v-btn-toggle v-model="renderMode" v-if="!isAdmin">
          <v-btn value="line">
            <v-icon>mdi-format-list-text</v-icon>
          </v-btn>
          <v-btn value="card">
            <v-icon>mdi-view-grid</v-icon>
          </v-btn>
        </v-btn-toggle>
        <NoticeActions
            v-if="isAdmin"
            :query="query"
            :selected-facets="selectedFacets"
            :online-filter="onlineFilter"
            :notice-collections-filter="noticeCollectionsFilter"
            :total-notices="totalNotices"
            :available-collections="noticeCollections"
            :only-has-image="onlyHasImage"
            v-on:finished="updateResults(1)"
            v-on:selectall="selectAll"
            v-on:unselectall="unselectAll"
        >
        </NoticeActions>
        <div style="position: relative;">
          <v-overlay
              :value="isListLoading"
              :absolute="true"
          >
            <v-progress-circular
                class="white--text"
                color="teal"
                indeterminate
                size="64"
            ></v-progress-circular>
          </v-overlay>

          <div v-if="isAdmin">
            <AdminNoticeItem v-for="notice in notices" :key="notice.id" :notice="notice"></AdminNoticeItem>
          </div>
          <v-container v-else fluid>
            <v-row dense>
              <v-col v-for="notice in notices" :key="notice.id" :cols="renderMode === 'line' ? 12 : 4">
                <FrontNoticeItem :key="notice.id" :notice="notice"></FrontNoticeItem>
              </v-col>
            </v-row>
          </v-container>
        </div>
        <div class="text-center">
          <v-pagination v-if="notices.length > 0"
                        v-model="pagination.page"
                        :length="pagination.pages"
                        :total-visible="9"
                        @input="next"
          ></v-pagination>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios'
import AdminNoticeItem from '@/components/AdminNoticeItem'
import FrontNoticeItem from '@/components/FrontNoticeItem'
import FacetAPI from '@/api/facet'
import NoticeCollectionAPI from '@/api/noticeCollections'
import NoticeActions from '@/components/NoticeActions'
import FrontSearch from '@/components/FrontSearch'
import NoticeMostViews from '@/components/NoticeMostViews'
import helper from '@/helper'

export default {
  name: 'ListNotices',
  components: {
    AdminNoticeItem,
    FrontNoticeItem,
    NoticeActions,
    FrontSearch,
    NoticeMostViews
  },
  props: [
    'isAdmin'
  ],
  data: () => ({
    ITEMS_PER_PAGE: 30,
    isListLoading: false,
    onlineFilter: 'all',
    onlyHasImage: 'all',
    randomize: false,
    showMostViewsNotices: false,
    searchEnabled: true,
    renderMode: 'line',
    noticeCollections: [],
    noticeCollectionsFilter: [],
    facets: [],
    notices: [],
    totalNotices: null,
    openedFacets: [],
    selectedFacets: [],
    query: null,
    pagination: {
      page: 1,
      pages: 1,
      items_per_page: 20,
    }

  }),
  mounted () {
    if (!this.isAdmin) {
      this.onlineFilter = 'online'
      const config = this.$store.state.config;
      if (config['notice_collection_code'] !== undefined)
        this.noticeCollectionsFilter.push(config['notice_collection_code'])
      if (config['render']['search_enabled'] !== undefined)
        this.searchEnabled = config['render']['search_enabled']
      if (config['render']['mode_list_notices'] !== undefined)
        this.renderMode = config['render']['mode_list_notices']
      // if (config['render']['show_only_notice_with_image'] !== undefined)
      //   this.onlyHasImage = config['render']['show_only_notice_with_image']
      if (config['render']['show_randomly_default_notice_list'] !== undefined)
        this.randomize = config['render']['show_randomly_default_notice_list']
      if (config['render']['show_most_views_notices'] !== undefined)
        this.showMostViewsNotices = config['render']['show_most_views_notices']
    }
    if(!helper.isEmpty(helper.getQueryParameter('query', false)))
      this.query = helper.getQueryParameter('query', false)
    if(!helper.isEmpty(helper.getQueryParameter('page', false)))
      this.pagination.page = parseInt(helper.getQueryParameter('page', false))

    this.updateResults(this.pagination.page)
    NoticeCollectionAPI.findAll().then(response => {
      this.noticeCollections = response.data['hydra:member'];
      this.noticeCollections.unshift({
        code: '',
        name: 'Sans collection'
      })
      this.$store.commit('setNoticeCollections', response.data['hydra:member'])
    })
  },
  methods: {
    submitAutocomplete(value){
      this.query = value
      this.updateResults(1)
    },
    removeFacet (value) {
      this.selectedFacets = this.selectedFacets.filter(function (selectedFacet) {
        return selectedFacet.id !== value.id
      })
    },
    selectAll () {
      let that = this
      this.notices.forEach(function (notice) {
        that.$store.commit('selectNotice', notice.id)
      })
    },
    unselectAll () {
      this.$store.commit('unselectAll')
    },
    updateUrl(){
      let url = '';
      url = helper.setQueryStringParameter('query', this.query)
      url = helper.setQueryStringParameter('f', this.selectedFacets.map(f => f.id))
      url = helper.setQueryStringParameter('o', this.openedFacets.map(f => f.id))

      this.saveSearch(url)
    },
    saveSearch(url){
      const search = {
        'query': this.query,
        'facets': this.selectedFacets.map(facet => facet.name),
        'url': url
      }
      if(search.query && search.url)
        this.$store.commit('addToSearchHistory', search)
    },
    updateResults (page = 1) {
      this.isListLoading = true
      this.$store.commit('unselectAll')
      this.pagination.page = page
      if(page !== 1)
        helper.setQueryStringParameter('page', page)
      this.getNotices()
      this.getFacets()
      this.updateUrl()
    },
    async fetchFacets (item, nextId = null) {
      return FacetAPI.tree(
        this.query,
        item.id,
        helper.convertArray(this.selectedFacets),
        helper.convertArray(this.openedFacets),
        this.onlineFilter,
        this.noticeCollectionsFilter.map(function (o) {return (o.code !== undefined) ? o.code : o}),
        this.onlyHasImage,
        true,
        nextId
      ).then(response => {
        const facets = this.parseFacets(response.data.data);
        if(nextId) item.children.push(...facets);
        else item.children = facets;
        if(item.children.length === 0) {
          item.hasChildren = false;
          return;
        }
        if(item.children.length < response.data.facetCount) this.fetchFacets(item, item.children[item.children.length - 1].id)
      })
    },

    next (page) {
      this.pagination.page = page
      helper.setQueryStringParameter('page', page)
      this.getNotices()
    },
    getFacets () {
      FacetAPI.tree(
          this.query,
          null,
          helper.convertArray(this.selectedFacets),
          helper.convertArray(this.openedFacets),
          this.onlineFilter,
          this.noticeCollectionsFilter.map(function (o) {return (o.code !== undefined) ? o.code : o}),
          this.onlyHasImage,
          true
      )
          .then(response => {
            this.facets = this.parseFacets(response.data, true);
            let nodes = this.$refs.tree.nodes;
            for (const nodeKey in nodes) {
              if (nodes[nodeKey].vnode) {
                nodes[nodeKey].vnode.hasLoaded = false
              }
            }
          })
    },

    parseFacets(facets, autoload = false) {
      facets.forEach( facet => {
        if (!facet.hasChildren) delete facet.children;
        if (facet.children?.length > 0) {
          this.parseFacets(facet.children);
          if (facet.children.length < facet.facetCount && autoload) this.fetchFacets(facet);
        }
      })
      return facets;
    },

    getNotices () {
      this.isListLoading = true;
      const params = {
        query: this.query,
        page: this.pagination.page,
        f: helper.convertArray(this.selectedFacets),
        items_per_page: this.pagination.items_per_page,
        onlineFilter: this.onlineFilter,
        noticeCollectionsFilter: this.noticeCollectionsFilter.map(function (o) {return (o.code !== undefined) ? o.code : o}),
        randomize: this.randomize
      };
      if( this.onlyHasImage !== 'all' ) params.onlyHasImage = this.onlyHasImage;
      axios
          .get('/api/v2/notices/search', { params })
          .then(response => {
            this.notices = response.data['hydra:member']
            this.totalNotices = response.data['hydra:totalItems']
            this.pagination.pages = Math.ceil(response.data['hydra:totalItems'] / this.pagination.items_per_page)
          })
          .catch(error => {
            console.error(error)
            this.errored = true
          })
          .finally(() => this.isListLoading = false)
    },
    addResultToCart() {
      this.notices.forEach((notice) => {
        this.$store.commit('addToCart', notice.id)
      })
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    }
  }
}
</script>
